import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";

/**
 * Emergent OAuth callback. Receives `#session_id=<sid>` in the URL hash,
 * exchanges it server-side for our JWT, stores tokens and redirects to /dashboard.
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login", { replace: true });
      return;
    }
    const session_id = decodeURIComponent(m[1]);
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id });
        if (data?.access_token) localStorage.setItem("access_token", data.access_token);
        if (data?.refresh_token) localStorage.setItem("refresh_token", data.refresh_token);
        // Strip the hash and bounce to dashboard. AuthProvider will pick up the token.
        window.location.replace("/dashboard");
      } catch (e) {
        setError(e?.response?.data?.detail || e.message || "Google sign-in failed");
        setTimeout(() => navigate("/login", { replace: true }), 2500);
      }
    })();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center space-y-3">
        <Loader2 className="h-6 w-6 animate-spin mx-auto text-primary" />
        <div className="text-sm text-muted-foreground">
          {error ? `Sign-in failed: ${error}` : "Completing Google sign-in…"}
        </div>
      </div>
    </div>
  );
}
